import { TagCategory } from '@exam-management/graphql';
import {
  DEFAULT_CRITERIA,
  DifficultyText,
  getDifficultyCriteria,
} from '@exam-management/qcontent-management'; // NOTE: Should these move to shared?
import { Flex, Text, ReadonlyField } from '@shared/components';

import { useSingleQuestionDetails } from '../../providers';

function NoInformationText() {
  return <Text color='textDisabled'>ยังไม่มีข้อมูล</Text>;
}

export default function InformationView() {
  const { singleQuestion } = useSingleQuestionDetails();

  const calculationTag = singleQuestion.tags.find(
    (tag) => tag.category === TagCategory.Calculation,
  );
  const calculation = calculationTag ? <Text>{calculationTag.name}</Text> : <NoInformationText />;

  const currentCriteria = getDifficultyCriteria(DEFAULT_CRITERIA, singleQuestion.pValue);

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
      <Flex sx={{ flex: 1 }}>
        <ReadonlyField label='ประเภทข้อสอบ' content={calculation} />
      </Flex>
      <Flex sx={{ flex: 1 }}>
        <ReadonlyField
          label='ค่า P Initial'
          content={
            typeof singleQuestion.pValue === 'number' ? (
              <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Text>{singleQuestion.pValue}</Text>
                <DifficultyText criteria={currentCriteria} />
              </Flex>
            ) : (
              <NoInformationText />
            )
          }
        />
      </Flex>
    </Flex>
  );
}
